import {
  ProfileMenuItemProps,
  doctorProfileMenuItems,
  patientProfileMenuItems,
  assistantProfileMenuItems,
  sharedProfileMenuItems,
  adminProfileMenuItems,
} from '../layout/menuItems'
import { UserType } from '../../models/graphqlTypes'
import { useMe } from './useMe'

export const useMenuItems = (): ProfileMenuItemProps[] => {
  const { data: { me } = {} } = useMe({ fetchPolicy: 'cache-only' })

  const menuItemsMap: Record<UserType, ProfileMenuItemProps[]> = {
    Doctor: doctorProfileMenuItems,
    Patient: patientProfileMenuItems,
    Assistant: assistantProfileMenuItems,
    Admin: adminProfileMenuItems,
  }

  const menuItems = me?.userType ? menuItemsMap[me.userType] : []

  return [...menuItems, ...sharedProfileMenuItems].filter((item) => {
    if (item.isLocationAdmin) {
      return me?.isAdmin || (me?.institutionPermissions?.length ?? 0) > 0
    }
    return true
  })
}
